import { CheckoutData, CheckoutStatus, RawCheckoutData } from 'merchant-api/types';
import { useApplication } from 'merchant-api/unified';
import { checkout } from '..';
import { queryOptions, useQuery, UseQueryResult, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDetailedOffers } from 'merchant-api/offer';
import { AppError } from '../../AppError';

interface CheckoutStateProps {
  isLoadingCheckoutState: boolean;
  isErrorCheckoutState: any;
  checkoutData?: CheckoutData;
  checkoutStatus?: CheckoutStatus;
  mutate: any;
  query: UseQueryResult<CheckoutData>;
}

export function getCheckoutState(): CheckoutStateProps {
  const queryClient = useQueryClient();
  const { applicationData, isLoadingApplication, isErrorApplication } = useApplication(['APPROVED']);
  const query = useQuery({
    ...getCheckoutOpts(applicationData?.id || ''),
    enabled: !!applicationData?.id,
  });
  const { data, error, isPending } = query;

  const checkoutData = data;
  const { selectedOffer, isLoadingDetailedOffers } = useDetailedOffers();
  useEffect(() => {
    if (isLoadingDetailedOffers || isPending) return;

    if (checkoutData?.offerUuid == null || selectedOffer?.offerId == null) return;

    if (checkoutData?.offerUuid != selectedOffer.offerId) throw AppError.OfferMismatch;
  }, [isLoadingDetailedOffers, isPending]);

  return {
    isLoadingCheckoutState: isPending || isLoadingApplication,
    isErrorCheckoutState: error || isErrorApplication,
    checkoutData: checkoutData,
    checkoutStatus: checkoutData?.checkoutStatus as CheckoutStatus,
    mutate: () =>
      queryClient.invalidateQueries({
        queryKey: ['checkout'],
      }),
    query,
  };
}

const getCheckout = (applicationId: string) =>
  checkout.get<RawCheckoutData[]>(`/v2/orchestration/state?applicationUuid=${applicationId}`).then(({ data }) => {
    return {
      ...data[0]?.data,
    };
  });

export const getCheckoutOpts = (applicationId?: string) =>
  queryOptions<CheckoutData>({
    queryKey: ['checkout'],
    queryFn: () => (applicationId ? getCheckout(applicationId) : ({} as CheckoutData)),
    refetchOnWindowFocus: false,
    enabled: !!applicationId,
  });
